import React, { Fragment, cloneElement } from 'react';
import type { FC } from 'react';
import type { AnyObject } from 'react-final-form';
import { useGetValue } from '@alfa-bank/site-form-utils/hooks/use-get-value';
import { getNamedContainersWithChildren } from '@alfa-bank/site-named-container/utils';

import type { IProps } from './models';
import { Context } from './context';

export const FormIterator: FC<IProps> = ({
    children,
    childrenDataTestId = 'iterated-element',
    className,
    name,
}) => {
    const {
        // TODO: попробовали типизировать namedContainers и вот такая история неявная выходит. IDE не подсвечивает как ошибку, а в терминале есть
        // скорее всего если тут дженерик типизировать, то все станет ок
        // @ts-ignore error TS7022: 'child' implicitly has type 'any' because it does not have a type annotation and is referenced directly or indirectly in its own initializer.
        children: child,
        content = child,
        wrapper,
        ...namedContainers
    } = getNamedContainersWithChildren(children);

    const getValue = useGetValue();
    const items = getValue(name);

    if (Array.isArray(items)) {
        const namedKeys = Object.keys(namedContainers);

        const elements = items.map((_: AnyObject, index: number) => {
            const element = (
                <Context.Provider
                    key={index}
                    value={{
                        currentRow: index,
                    }}
                >
                    <div data-test-id={`${childrenDataTestId}-${index}`}>{content}</div>
                </Context.Provider>
            );

            return namedKeys.includes(index.toString()) ? (
                <Fragment key={index}>
                    <div data-test-id={`named-${childrenDataTestId}`}>{namedContainers[index]}</div>
                    {element}
                </Fragment>
            ) : (
                element
            );
        });

        if (wrapper) {
            return (
                <div className={className}>
                    {cloneElement(wrapper as JSX.Element, {
                        children: elements,
                    })}
                </div>
            );
        }

        return <div className={className}>{elements}</div>;
    }

    return null;
};
